import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CollapseComponent = styled('div')`
  overflow: hidden;
  transition: all 200ms ease-in-out;
`;

const TrickyDiv = styled('div')`
  height: 1px;
  margin-bottom: -1px;
`;

function Collapse({ children, show }) {
  const [style, setStyle] = useState({
    height: show ? 'auto' : 0,
    overflow: show ? 'visible' : 'hidden',
    opacity: show ? 1 : 0
  });

  const container = useRef();
  const hideTimeout = useRef();
  const showTimeout = useRef();

  const getHeight = () => container.current.getBoundingClientRect().height;

  useLayoutEffect(() => {
    if (show) {
      if (hideTimeout.current) {
        window.clearTimeout(hideTimeout.current);
      }

      setStyle({
        height: getHeight(),
        overflow: 'hidden',
        opacity: 1
      });

      showTimeout.current = window.setTimeout(() => {
        setStyle({
          height: 'auto',
          overflow: 'visible',
          opacity: 1
        });
      }, 200);
    }

    if (!show) {
      if (showTimeout.current) {
        window.clearTimeout(showTimeout.current);
      }

      setStyle({
        height: getHeight(),
        overflow: 'hidden',
        opacity: 1
      });

      hideTimeout.current = window.setTimeout(() => {
        setStyle({
          height: 0,
          overflow: 'hidden',
          opacity: 0
        });
      }, 1);
    }
  }, [show]);

  return (
    <CollapseComponent style={style}>
      <div ref={container}>
        {children}
        <TrickyDiv />
      </div>
    </CollapseComponent>
  );
}

Collapse.propTypes = {
  show: PropTypes.bool
};

export default Collapse;
